import { OutlinedInput, OutlinedInputProps, SxProps } from '@mui/material';
import { forwardRef, InputHTMLAttributes, useMemo } from 'react';
import PhoneInputWithCountrySelect, { Value } from 'react-phone-number-input';
import CountriesPhoneCodeSelect from './CountriesPhoneCodeSelect';

interface CustomPhoneNumberInputProps {
  onChange: (phoneNumber?: Value) => void;
  value?: Value;
  inputPlaceholder?: string;
  selectSx?: SxProps;
  inputSx?: SxProps;
  inputProps?: OutlinedInputProps;
}

export default function CustomPhoneNumberInput({ onChange: onPhoneNumberChange, value: phoneNumber, selectSx, inputSx, inputProps, inputPlaceholder }: CustomPhoneNumberInputProps): React.JSX.Element {
  const ForwardedInputComponent = useMemo(() => {
    // eslint-disable-next-line react/display-name
    return forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
      (props, ref) => {
        const { onChange, value, type } = props;

        return (
          <OutlinedInput
            inputRef={ref}
            onChange={onChange}
            value={value}
            type={type}
            sx={inputSx}
            placeholder={inputPlaceholder}
            {...inputProps}
          />
        );
      },
    );
  }, [inputProps?.disabled]);

  return (
    <PhoneInputWithCountrySelect
      onChange={onPhoneNumberChange}
      value={phoneNumber}
      defaultCountry="FR"
      initialValueFormat="national"
      inputComponent={ForwardedInputComponent}
      countrySelectComponent={CountriesPhoneCodeSelect}
      countrySelectProps={{
        disabled: inputProps?.disabled,
        selectSx,
      }}
      style={{
        display: 'flex',
        gap: 8,
      }}
    />
  );
}
